import { Money } from "../../utils/money";
import { DriverType } from "../delivery-company/drivers";
import { MerchantType } from "../delivery-company/merchants";
import { OrderType } from "../delivery-company/orders";
import { IOrderDeliveryTask, IPickupTask } from "../delivery-company/tasks";
import { TotalAmounts } from "./invoice";

export enum DriverInvoiceState {
    PENDING_PAYMENT = "PENDING_PAYMENT",
    PAID = "PAID"
}

export enum DriverInvoiceType {
    PICKUP = "PICKUP",
    DELIVERY = "DELIVERY",
    COMMISSION = "COMMISSION",
}

export enum DriverInvoicePurpose {
    NET = "NET",
    COLLECTION = "COLLECTION",
    COMMISSION = "COMMISSION",
}

export interface IDriverInvoice {
    id: string;
    type: DriverInvoiceType,
    notes: string;
    created_at: string;
    driver: DriverType | null,
    total_amounts: TotalAmounts;
    orders: OrderType[];
    tasks: IPickupTask[];
    packages: number;
    task_count: number;
    status: DriverInvoiceState;
    delivery_attempts: IOrderDeliveryTask[];
    settlement_mode: 'NET' | 'GROSS';
    purpose: 'NET' | 'COLLECTION' | 'COMMISSION';
}